const CANCELLATION_POLICY = {
  NON_REFUNDABLE: "NonRefundable",
  FREE: "Free",
  FEE_APPLIES: "FeeApplies",
  UNKNOWN: "Unknown",
};

export default CANCELLATION_POLICY;
